import type { PromoContentSwitcher } from '#shared/types/storyblok/PromoContentSwitcher';

type Block = { component: string; _uid: string };

const isPromoContentSwitcher = (block: Block): block is PromoContentSwitcher =>
    block.component === 'promo_content_switcher';

const activePromoContentBlocks = (switcher: PromoContentSwitcher): Block[] =>
    (switcher.is_promo_active
        ? switcher.during_promo
        : switcher.before_after_promo) ?? [];

export const flattenPromoContentSwitchers = (blocks: Block[]): Block[] =>
    blocks.flatMap((block) =>
        isPromoContentSwitcher(block)
            ? flattenPromoContentSwitchers(activePromoContentBlocks(block))
            : [block],
    );
